[
  {"code": "AT", "country": "Austria", "vat_rate": 20.0},
  {"code": "BE", "country": "Belgium", "vat_rate": 21.0},
  {"code": "BG", "country": "Bulgaria", "vat_rate": 20.0},
  {"code": "HR", "country": "Croatia", "vat_rate": 25.0},
  {"code": "CY", "country": "Cyprus", "vat_rate": 19.0},
  {"code": "CZ", "country": "Czech Republic", "vat_rate": 21.0},
  {"code": "DK", "country": "Denmark", "vat_rate": 25.0},
  {"code": "EE", "country": "Estonia", "vat_rate": 20.0},
  {"code": "FI", "country": "Finland", "vat_rate": 24.0},
  {"code": "FR", "country": "France", "vat_rate": 20.0},
  {"code": "DE", "country": "Germany", "vat_rate": 19.0},
  {"code": "GR", "country": "Greece", "vat_rate": 24.0},
  {"code": "HU", "country": "Hungary", "vat_rate": 27.0},
  {"code": "IE", "country": "Ireland", "vat_rate": 23.0},
  {"code": "IT", "country": "Italy", "vat_rate": 22.0},
  {"code": "LV", "country": "Latvia", "vat_rate": 21.0},
  {"code": "LT", "country": "Lithuania", "vat_rate": 21.0},
  {"code": "LU", "country": "Luxembourg", "vat_rate": 16.0},
  {"code": "MT", "country": "Malta", "vat_rate": 18.0},
  {"code": "NL", "country": "Netherlands", "vat_rate": 21.0},
  {"code": "PL", "country": "Poland", "vat_rate": 23.0},
  {"code": "PT", "country": "Portugal", "vat_rate": 23.0},
  {"code": "RO", "country": "Romania", "vat_rate": 19.0},
  {"code": "SK", "country": "Slovakia", "vat_rate": 20.0},
  {"code": "SI", "country": "Slovenia", "vat_rate": 22.0},
  {"code": "ES", "country": "Spain", "vat_rate": 21.0},
  {"code": "SE", "country": "Sweden", "vat_rate": 25.0}
]
